<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <a class="me-2 btn btn-option mb-2" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                            </a>
                        </div>
                    </div>
                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable">
                            <thead>
                            <tr>
                                <th>SI</th>
                                <th>Category Name</th>
                                <th class="text-end" v-for="month in reportData.months">
                                    <router-link :to="{name: 'categoryDailyExpenseReport', params: {project_id: this.$route.params.project_id, year: this.$route.params.year, month_name:month}}">{{ month }}</router-link>
                                </th>
                                <th class="text-end">Total</th>
                            </tr>
                            </thead>
                            <template v-if="!loading && reportData?.data?.length > 0">
                                <tbody>
                                    <tr v-for="(data,index) in reportData.data">
                                        <td>{{ index + 1 }}</td>
                                        <td>
                                           {{ data.category_name }}
                                        </td>
                                        <td class="text-end" v-for="amount in data.amount_format">{{ amount }}</td>
                                        <td class="text-end">{{ data.total }}</td>
                                    </tr>
                                </tbody>
                                    <tfoot>
                                        <th class="text-end" colspan="2">Total</th>
                                        <th class="text-end" v-for="total in reportData.total">{{ total }}</th>
                                        <th class="text-end">{{ reportData.grandTotal }}</th>
                                    </tfoot>
                            </template>
                            <template v-if="!loading && reportData?.data?.length === 0">
                                <tr class="text-center">
                                    <td colspan="100" class="fw-bold fs-6 text-height">
                                        No Data Found
                                        <br>
                                        Please search by project.
                                    </td>
                                </tr>
                            </template>

                            <tbody v-if="loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue.vue";
import Table from "../Common/Table.vue";
import Breadcrumb from "../Common/Breadcrumb.vue";
import Unit from "../Settings/Unit/Unit.vue";
import Loader from "../Common/Loader.vue";

export default {
    components: {Loader, Unit, Breadcrumb, Table, ConfirmDialogue},
    data() {
        return {
            breadCrumb: ['Category Monthly Expense'],
            reportData: [],
            projects: [],
            costingItems: [],
            params: {
                project_id: '',
            },
            loading: false,
            exportLoading: false,
            date: ''

        }
    },
    methods: {
        downloadFile: function () {
            PrintService.print('/print/category-monthly-expense?project_id='+this.$route.params.project_id + '&year=' +  this.$route.params.year);
        },
        handleData() {
            this.loading = true;
            ApiService.POST(ApiRoutes.Report + '/category-monthly-expense', {year: this.$route.params.year, project_id: this.$route.params.project_id}, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.reportData = res;
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        }
    },
    created() {
        this.handleData();
    }
}
</script>

<style scoped>

</style>
